$(document).ready(function () {

  var MTIProjectId = '1f07e91d-b88a-4dd2-946c-0079298a701f';
  (function () {
    var mtiTracking = document.createElement('script');
    mtiTracking.type = 'text/javascript';
    mtiTracking.async = 'true';
    mtiTracking.src = 'resources/app/client/dist/js/mtiFontTrackingCode.js';
    (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(mtiTracking);
  })();

  $("a#menue_einblenden").click(function (event) {
    event.preventDefault();
    $("nav#mobile_nav").slideDown(200);
  });
  var ismobile = $("a#menue_einblenden:visible").length;
  $("#mobile_nav .menue #nav li a").click(function (e) {
    var href = $(this).attr("href");
    if (href.startsWith("http")) {
      $("nav#mobile_nav").slideUp(200);
      return true;
    }
    e.preventDefault();
    //alert("#main_nav a#"+id);
    $("#main_nav a[href=\"" + href + "\"]").click();
    $("nav#mobile_nav").slideUp(200);
  });
  $("#x a").click(function (e) {
    e.preventDefault();
    $("nav#mobile_nav").slideUp(200);
  });

  $(".galerie").each(function () {
    var $galerie = $(this);
    var $container = $(".bilder", $(this));
    var $buttons = $(".button", $(this));

    $buttons.click(function (e) {
      e.preventDefault();
      $(".inserted_details").fadeOut().remove();
      $(".button", $galerie).not($(this)).removeClass("active");
      $(this).addClass("active");
      var filterValue = $(this).attr('data-category');
      // $container.isotope({ filter: filterValue });
      // $("[data-category!=\""+filterValue+"\"]").hide();
      $("> section", $container).removeClass('visible');
      $("[data-category=\"" + filterValue + "\"]", $galerie).addClass('visible');
    });

    $buttons.first().click();
  });

  $("body").on("click", ".galerie section", function () {
    $(".inserted_details").fadeOut().remove();

    //Search correct insertion point: Last with same offset
    var $insertionpoint;
    var myoffset = $(this).offset().top;
    $("section", $(this).parent()).each(function () {
      if ($(this).offset().top == myoffset)
        $insertionpoint = $(this);
    });
    if ($(this).hasClass("item--open")) {
      $(".item--open").removeClass("item--open");
    } else {
      $(".item--open").removeClass("item--open");
      $(this).addClass("item--open");

      //Insert details and show
      var $details = $(".bilder_content", $(this)).clone().insertAfter($insertionpoint);//.slideDown("slow");
      $details.each(function () {
        var redraw = this.offsetHeight
      });
      $details.addClass("inserted_details");
    }
  })

  $('#introvideo').on('timeupdate', function () {
    if (this.currentTime >= 22) {
      $('.home_title').fadeTo(2000, 1, function () {
        // Animation complete.
      });
    }
  });
});


import Splide from '@splidejs/splide';

new Splide( '.splide', {
  type: 'fade',
  rewind: true,
  drag: true,
  height: '100%',
  autoplay: true,
  interval: 4000,
  speed: 2000,
  arrows: false,
  pauseOnHover: false,
}).mount();
